export default (entity = {}) => {
    return {
        id: entity.id || undefined,
        name: entity.name || '',
        address: entity.address || '',
        lat: entity.lat || '',
        lng: entity.lng || '',
        timezone: entity.timezone || 'Asia/Jerusalem',
        currencyCode: entity.currencyCode || 'ILS',
        imageGuid: entity.imageGuid || undefined,
        imageUrl: entity.imageUrl || undefined,
        supportCorporateDelivery: entity.hasOwnProperty('supportCorporateDelivery') ? entity.supportCorporateDelivery : true,
        deliveryInfo: entity.deliveryInfo || null,
    };
};
